export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11652.454c6ec8.jpg";